import { Card, Col, Row, Label, ReactSelectBox, Quantity, PrimaryButton, Checkbox, Tooltip , RadioContainer } from "client/CommonComponents";
import "./CreateNewRequisition.scss";
import ReceivingBranch from "./ReceivingBranch";
import TransferAsset from "./TransferAsset";
import { useEffect } from "react";
import Reactivations from "./Reactivations";
import Information from "./Information";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import Disposition from "./Disposition";
import AssetInformation from "./Disposition/AssetInformation";
import Afereclassification from "./AFEReclassification/Afereclassification-container";
import { CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";

const CreateNewRequisition = (props: any) => {
  const {
    branchTypeDropdownList,
    requisitionTypeDropdownList,
    onChangeBranch,
    onChangeRequestType,
    branchValue,
    requestType,
    popupContent,
    setExpandedItems,
    dismissSuccessAlert,
    showTransferAssetDetail,
    setShowTransferAssetDetail,
    setShowCart,
    successInfoAlert,
    setShowCartClicked,
    mobile,
    setShowCreateRequisition,
    setSuccessAlert,
    showDispositionInformation,
    setShowDispositionInformation,
    onChangeQuantity,
    incrementQuantity,
    decrementQuantity,
    quantity,
    onClickAdd,
    clickedAdd,
    setErrorAlert,
    onCancelClick,
    isEditOrder,
    isRevertChanges,
    setIsRevertChanges,
    updateCartStateRef,
    setUpdateCartRef,
    isPreAuthorized,
    handlePreAuthorizedFlagChange,
    initialState,
    setAssetDetailList,
    assetDetailList,
    setTotalPenaltyFee,
    totalPenaltyFee,
    setShoweExemptionFields,
    showExemptionFields,
    transferOrderByIdData,
    isCostCenterAvailableForSubmit,
    showCart,
    afeTypeList ,
    handleChangeAFEType,
    selectedAfeType,
    setClickedAdd,
    showAFEInfoMessage,
    isAFEPreAuthorized
  } = props

  const getPreAuthorizedState = () => {
    return requestType?.label === CONSTANTS.AFEREQUEST ? isAFEPreAuthorized : isPreAuthorized;
  }

  const selectedVehicle = () => {
    if (requestType?.label === CONSTANTS.TRANSFER) {
      return (<>
        {successInfoAlert && clickedAdd && <Information successInfoAlert={successInfoAlert} dismissSuccessAlert={dismissSuccessAlert} />}
        {showTransferAssetDetail &&
          <TransferAsset
            setShowCart={setShowCart}
            setShowCartClicked={setShowCartClicked}
            mobile={mobile}
            setShowCreateRequisition={setShowCreateRequisition}
            setSuccessAlert={setSuccessAlert}
            setErrorAlert={setErrorAlert}
            setShowTransferAssetDetail={setShowTransferAssetDetail}
            isRevertChanges={isRevertChanges}
            setIsRevertChanges={setIsRevertChanges}
            quantity={quantity}
            onCancelClick={onCancelClick}
            showCart = {showCart}
          />
        } 
      </>)
    } else if (requestType?.label === CONSTANTS.REACTIVATION && clickedAdd) {
      return <Reactivations
        setShowCart={setShowCart}
        setShowCartClicked={setShowCartClicked}
        mobile={mobile}
        setShowCreateRequisition={setShowCreateRequisition}
        setSuccessAlert={setSuccessAlert}
        setErrorAlert={setErrorAlert}
        isRevertChanges={isRevertChanges}
        setIsRevertChanges={setIsRevertChanges}
        quantity={quantity}
        onCancelClick={onCancelClick}
        showCart={showCart}
      />
    } else if (requestType?.label === CONSTANTS.DISPOSITION && clickedAdd) {
      return (<>
        <AssetInformation
          setShowDispositionInformation={setShowDispositionInformation}
          quantity={quantity}
          onCancelClick={onCancelClick}
          setShowCartClicked={setShowCartClicked}
          setShowCart={setShowCart}
          setShowCreateRequisition={setShowCreateRequisition}
          isRevertChanges={isRevertChanges}
          setIsRevertChanges={setIsRevertChanges}
          mobile={props.mobile}
          setUpdateCartRef={setUpdateCartRef}
          initialState={initialState}
          setAssetDetailList={setAssetDetailList}
          assetDetailList={assetDetailList}
          setTotalPenaltyFee={setTotalPenaltyFee}
          totalPenaltyFee={totalPenaltyFee}
          setShoweExemptionFields={setShoweExemptionFields}
          showExemptionFields={showExemptionFields}
        />
        {
          showDispositionInformation &&
          <Disposition
            setShowCart={setShowCart}
            setShowCartClicked={setShowCartClicked}
            mobile={mobile}
            setSuccessAlert={setSuccessAlert}
            setShowCreateRequisition={setShowCreateRequisition}
            onCancelClick={onCancelClick}
            isRevertChanges={isRevertChanges}
            setIsRevertChanges={setIsRevertChanges}
            updateCartStateRef={updateCartStateRef}
            setAssetDetailList = {setAssetDetailList}
            assetDetailList = {assetDetailList}
            setTotalPenaltyFee = {setTotalPenaltyFee}
            totalPenaltyFee = {totalPenaltyFee}
            setShoweExemptionFields = {setShoweExemptionFields}
            showExemptionFields = {showExemptionFields}
          />
        }
      </>
      )

    } else if (requestType?.label === CONSTANTS.AFEREQUEST && clickedAdd && !showAFEInfoMessage) {
      return(
      <Afereclassification
      selectedAfeType = {selectedAfeType}
      setClickedAdd = {setClickedAdd} />
      )
    }
  }

const checkToShowDetails = () => {
  if(requestType?.label === CONSTANTS.AFEREQUEST){
    return selectedAfeType?.label && selectedAfeType?.value !== null && selectedAfeType?.label !== "Select Vehicle Type" ? true : false
  }else{
    return true;
  }
}

  useEffect(() => {
    setExpandedItems(selectedVehicle());
  }, [requestType])

  const isAddDisable = ()=>{
    if(requestType?.label === CONSTANTS.AFEREQUEST && clickedAdd){
      return true;
    }
    return false;
  }

  return (
    <>
      <Row>
        <Col xs={12} md={12} lg={12} className='createRequisition createRequisition-asset'>
          <Card data-attribute="CreateNewRequisition_Default_Card">
            <div>
              <Row>
                <Col xs={12} md={4} lg={4}>
                  <p className='headingText mb-0'>MANAGE EXISTING ASSETS</p>
                  <p className='subText subText-width mb-2'>Select below options to manage existing assets</p>
                </Col>
                <Col xs={12} md={4} lg={4} className='mt-2 mt-sm-0'>
                  {isEditOrder ?
                    <>
                      <p className='flexDisplay'>
                        <p className='createdText'> Created By - </p>
                        <Tooltip content={transferOrderByIdData?.requestedBy ? transferOrderByIdData?.requestedBy : "-"} data-attribute="CreateNewRequisition_Default_Tooltip">
                          <p className='createdContent'>{transferOrderByIdData?.requestedBy ? transferOrderByIdData?.requestedBy : "-"}</p>
                        </Tooltip>
                      </p>
                    </>
                    : null
                  }
                </Col>

                <Col xs={12} md={4} lg={4} className={'mt-2 mt-sm-0 pull-right MA-checkbox disposition-approval-override'}>
                  {(isAuthorized(permissions.SetPreAuthorized)) ? <Checkbox
                    label='Approval Override(Pre-Authorized)'
                    className='mb-0 pull-right'
                    checked={!!getPreAuthorizedState()}
                    onChange={(e: any, value: any) => handlePreAuthorizedFlagChange(e, value)}
                   data-attribute="CreateNewRequisition_Approval_Override_Pre_Authorized_Checkbox" /> : null}
                </Col>
              </Row>
            </div>
            <div>
            {(selectedAfeType.label == CONSTANTS.BUILDING_IMPROVEMENTS) &&
              <Row>
                <Col xl={5} md={5} sm={10} className="pt-3"></Col>
                <Col xl={3} md={3} sm={6} className="pt-3"></Col>
                <Col xl={3} md={3} sm={6} className="pt-3">
                  <div className='Doclabel_tooltip lookuplinkWrapper'>
                    <Label data-attribute="CreateNewRequisition_Default_Label">Lease ID #
                      <span>
                                  <Tooltip content={"Please use the 'LeaseID Lookup' link to access file with Lease IDs, addesses and expiration dates."} data-attribute="CreateNewRequisition_Default_Tooltip_2">
                                      <span className="fa fa-info-circle attachment-info ms-1"></span>
                                  </Tooltip>
                              </span>
                          </Label>
                          <a
                              href={process.env.REACT_APP_LEASEID_LOOKUP_URL}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="leaseid-lookup-link"
                          >
                              LeaseID Lookup
                          </a>
                      </div>
                  </Col>
                </Row>
              }
            </div>
            <Row className="createRequisition_TopSection">
              <Col xs={12} md={4} xl={3} lg={4}>
                <div>
                  <Label required data-attribute="CreateNewRequisition_Default_Label_2">Request Type</Label>
                  <ReactSelectBox
                    options={requisitionTypeDropdownList}
                    onChange={(item: any, e: any) => onChangeRequestType(e, item)}
                    value={requestType}
                    className={clickedAdd && !requestType?.label ? 'controlValidation' : ""}
                    selectRef={(element: any) => props.RequestTypeFieldRef.current[0] = element}
                    isDisabled={isEditOrder ? true : false}
                   data-attribute="CreateNewRequisition_Default_SearchSelectBox" />
                  {clickedAdd && !requestType?.label ? <p className='validMessage mt-0'>{"Please select request type"}</p> : ""}
                </div>
              </Col>
              <Col xs={12} md={4} xl={3} lg={4} className='mt-2 mt-sm-0'>
                <div>
                  <Label data-attribute="CreateNewRequisition_Default_Label_3">Current Branch</Label>
                  <ReactSelectBox
                    options={branchTypeDropdownList}
                    onChange={(item: any, e: any) => onChangeBranch(e, item)}
                    value={branchValue ? branchValue : ""}
                    defaultValue={branchValue}
                    isSearchable={true}
                    isDisabled={isEditOrder ? true : false}
                    className={(!branchValue || !isCostCenterAvailableForSubmit) ? 'controlValidation' : ""}
                   data-attribute="CreateNewRequisition_Default_SearchSelectBox_2" />
                </div>
                {!isCostCenterAvailableForSubmit ? <p className="branch-error"><b>Note:</b> Branch is not available in your location, please save if available.</p> : null}
              </Col>
              {requestType?.label === CONSTANTS.AFEREQUEST && (
                <>
              <Col xs={12} md={4} xl={3} lg={4} className="mt-3 mt-md-0 mt-xl-0 mt-lg-0" >
                <div>
                  <Label required data-attribute="CreateNewRequisition_Default_Label_4">AFE Type</Label>
                  <ReactSelectBox
                    placeholder="Select an option"
                    options={afeTypeList}
                    value={selectedAfeType}
                    onChange={(item: any, e: any) => handleChangeAFEType(e, item)}
                    isDisabled={isEditOrder ? true : false}
                    className={selectedAfeType?.value === null || selectedAfeType?.label === "Select Vehicle Type" ? 'controlValidation' : "custom-class"}
                   data-attribute="CreateNewRequisition_Default_SearchSelectBox_3" />
                  {(selectedAfeType?.value === null || selectedAfeType?.label === "Select Vehicle Type" || (!selectedAfeType?.label && clickedAdd)) ? <p className='validMessage mt-0'>{"Please select AFE type"}</p> : ""}
                </div>
              </Col>
              </>
              )}
              {!(requestType?.label === CONSTANTS.AFEREQUEST) && (
                <Col xs={9} md={2} lg={2} className='mt-2 mt-sm-0'>
                  <div className="asset-qty">
                    <Label data-attribute="CreateNewRequisition_Default_Label_5">Qty of Assets</Label>
                    <Quantity
                      increment={incrementQuantity}
                      decrement={decrementQuantity}
                      value={quantity}
                      disableFlg={quantity > 1 ? false : true}
                      // onKeyPress={(event: any) => { isMaxLength(event, 2) }}
                      onChange={onChangeQuantity}
                      inputRef={(element: any) => props.RequestTypeFieldRef.current[1] = element}
                     data-attribute="CreateNewRequisition_Default_Quantity" />
                  </div>
                </Col>
              )}
              <Col xs={3} md={2} lg={2} className={'mt-2 mt-sm-0 pull-right ' + (clickedAdd && !requestType?.label ? "asset-qty-add-validation" : " ")}> 
                <div className="meaBtn">
                  <PrimaryButton 
                    text='Add' 
                    onClick={onClickAdd} 
                    btnRef={(element: any) => props.RequestTypeFieldRef.current[2] = element}
                    disabled={isAddDisable()}
                   data-attribute="CreateNewRequisition_Default_Button" />
                </div>
              </Col>
            </Row>
          </Card>
          {
            branchValue?.label && requestType?.label && checkToShowDetails() ?
              <div className='requestTypeAccord mt-3'>
                {selectedVehicle()}
              </div> : null
          }
        </Col>
      </Row>

      {popupContent.isDialogVisible ? <CancelConfirmationPopup
        hideDialog={!popupContent.isDialogVisible}
        onDismiss={popupContent.hideDialog}
        Popupcontent={popupContent}
        popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
      /> : ""}
    </>
  );
};

export default CreateNewRequisition;
